import axios from 'axios'

export default {
  getCities (cb) {
    get('/cities', cb)
  },
  getDistricts (cb) {
    get('/cities/districts', cb)
  },
  getStreets (cb) {
    get('/cities/districts/streets', cb)
  },
  updateStreet (id, item, cb) {
    update('/cities/districts/streets/' + id, item, cb)
  },
  addStreet (item, cb) {
    post('/cities/districts/streets', item, cb)
  },
  deleteStreet (item, cb) {
    del('/cities/districts/streets/' + item.id, item, cb)
  },
  getTourTemplates (cb) {
    get('/tour/templates', cb)
  },
  addTourTemplate (item, cb) {
    post('/tour/template', item, cb)
  },
  updateTourTemplate (item, cb) {
    update('/tour/template/' + item.id, item, cb)
  },
  deleteTourTemplate (item, cb) {
    del('/tour/template/' + item.id, item, cb)
  },
  getTour (cb) {
    get('/tour', cb)
  },
  addTour (item, cb) {
    post('/tour', item, cb)
  },
  updateTour (item, cb) {
    update('/tour/' + item.id, item, cb)
  },
  deleteTour (item, cb) {
    del('/tour/' + item.id, item, cb)
  },
  getDevices (cb) {
    get('/devices', cb)
  },
  getDuties (cb) {
    get('/duties', cb)
  },
  getDuty (item, cb) {
    get('/duty/' + item.id, cb)
  },
  updateDuty (id, item, cb) {
    update('/duty/' + id, item, cb)
  },
  addDuty (item, cb) {
    post('/duty', item, cb)
  },
  deleteDuty (item, cb) {
    del('/duty/' + item.id, item, cb)
  },
  sendMail (id, item, cb) {
    update('/duty/email/' + id, item, cb)
  },
  updatePassword (item, cb) {
    update('/user/profile', item, cb)
  },
  login (data, cb) {
    post('/login_check', data, cb)
  },
  downloadTourPdf (id, filename) {
    console.log('Tour PDF')
    axios({
      url: '/tour/' + id + '/pdf',
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  },
  downloadTourMapPdf (id, filename) {
    console.log('Map PDF')
    axios({
      url: '/tour/' + id + '/pdf/map',
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  },
  getCompanies (cb) {
    get('/companies', cb)
  },
  updateCompany (item, cb) {
    update('/company/' + item.id, item, cb)
  },
  addCompany (item, cb) {
    post('/company', item, cb)
  },
  deleteCompany (item, cb) {
    del('/company/' + item.id, item, cb)
  },
  getVehicles (cb) {
    get('/vehicles', cb)
  },
  updateVehicle (item, cb) {
    update('/vehicle/' + item.id, item, cb)
  },
  addVehicle (item, cb) {
    post('/vehicle', item, cb)
  },
  deleteVehicle (item, cb) {
    del('/vehicle/' + item.id, item, cb)
  }
}

function get (url, cb) {
  axios.get(url)
    .then(function (response) {
      if (response.status === 200) {
        cb(response.data)
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function update (url, item, cb) {
  axios.put(url, item)
    .then(function (response) {
      if (response.status === 200) {
        cb(response.data)
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function post (url, data, cb) {
  axios.post(url, data)
    .then(function (response) {
      if (response.status === 200) {
        cb(response.data)
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function del (url, data, cb) {
  axios.delete(url)
    .then(function (response) {
      if (response.status === 200) {
        cb(response.data)
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/api.js